import React from "react";

export function FragmentHeaderSubsidiary({ addSubsidiary }) {
    return (
        <div className="flex items-center gap-3">
            <button
                type="button"
                onClick={addSubsidiary}
                className="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
            >
                <i className="fas fa-plus"></i>
                Registrar Sucursal
            </button>
        </div>
    );
}
